import React, { Component } from "react";
import ColmunFooter from "./ColmunFooter";
import footerDataCollections from "./data/FooterData";

export default class FooterLinksWrapper extends Component {
  render() {
    return (
      <div className="footer-links-wrapper row">
        {footerDataCollections.map((section, i) => (
          <div className={`links-wrapper-${i + 1} col-sm-12 col-md`} key={i}>
            <ColmunFooter data={section}/>
     
          </div>
        ))}
      </div>
    );
  }
}
